<template>
  <app-base
    ref="appRef"
    :topbar-props="topbarProps"
    @topbar-start="onTopbarStart"
  />
</template>

<script setup>
import AppBase from '../common/AppBase'
import Auth from './Auth'
import { useShellStore } from '@/store'
import { storeToRefs } from 'pinia'
import { Channel } from 'frontendcommon-3'
import { ref, watch, onMounted } from 'vue'

const auth = new Auth()
const shellStore = useShellStore()
const { tokens, userInfo } = storeToRefs(shellStore)
const appRef = ref()
let __topbar

// Delegations

const delegations = ref({
  delegations: [],
  organization: null
})

if (!delegations.value.delegations.length) {
  auth.fetchDelegations(shellStore.tokens.farmacloud.jti).then((data) => {
    delegations.value = data
    __topbar?.setDelegations(delegations.value)
  }).catch(() => {})
}

// Customization

function setCustomization () {
  const customization = userInfo.value.customization_info.data
  __topbar?.setPrimaryColor(customization.colors.primary_color.hex_color)
  shellStore.SET_CUSTOMIZATION({
    logo_color: customization.logo,
    logo_small_color: customization.logo_small,
    link_logo_url: customization.link_logo_url,
    primary_color: customization.colors.primary_color.hex_color,
    secondary_color: customization.colors.secondary_color.hex_color
  })
}

watch(userInfo, setCustomization)

// Topbar

const topbarProps = {
  'data-state': shellStore.tokens.farmacloud.state
}

function onTopbarStart (topbar) {
  __topbar = topbar
  // Set customization
  setCustomization()
  // Set delegations
  topbar.setDelegations(delegations.value)
  // Show log in security message
  const secured = localStorage.getItem('secured')
  if (!secured) {
    topbar.setSecured(true)
    localStorage.setItem('secured', 1)
  }
  // Listen for events
  topbar.addEventListener('switch-user', async () => {
    if (auth.validateToken(tokens.value)) {
      appRef.value.setResetKey()
    }
  })
  topbar.addEventListener('change-delegation', async ({ detail: delegationUuid }) => {
    await auth.switchDelegation(delegationUuid, shellStore.tokens.farmacloud.jti)
    appRef.value.setResetKey()
  })
}

// Channel events

onMounted(() => {
  // TODO: remove all once farmacloud micros are all refactored to vue3
  // Channel.onTokenChanged
  const channel = new Channel()
  channel.onTokenRefreshEnd(async ({ detail }) => {
    const newJti = detail.tokens?.jti
    if (newJti) __topbar?.setToken({ token: newJti })
  })

  window.addEventListener('token-changed', async () => {
    const tokenData = await auth.fetchToken()
    auth.validateToken(tokenData?.farmacloud)
    // Update tokens
    shellStore.SET_TOKENS(tokenData)
    // Update topbar token
    const newJti = tokenData?.farmacloud?.jti
    if (newJti) __topbar?.setToken({ token: newJti })
    // Emit token-changed-end
    window.dispatchEvent(new CustomEvent('token-changed-end'))
  }, false)

  // Channel.onSetNavLinks
  window.addEventListener('set-nav-links', ({ detail: navLinks }) => {
    navLinks.forEach((item, index) => { item.id = item.id || index })
    Channel.emitUpdateSidebarItems(navLinks)
  }, false)

  // Channel.onRemoveSidebar
  window.addEventListener('remove-sidebar', ({ detail: value }) => {
    shellStore.SET_SHOW_SIDEBAR(value)
  }, false)
})
</script>
